<template>
  <div class="commission-debt-page">
    <KTCodePreview v-bind:title="title">
      <template v-slot:preview>
        <b-tabs v-model="activeTab" content-class="mt-4" pills>
          <b-tab title="Tổng kỳ" active>
            <SummaryTab v-if="activeTab === 0" @drilldown="onDrilldown" />
          </b-tab>
          <b-tab title="Chi tiết">
            <DetailTab v-if="activeTab === 1" :prefill="detailPrefill" />
          </b-tab>
          <b-tab title="Hiệu suất voucher">
            <VoucherPerformanceTab v-if="activeTab === 2" />
          </b-tab>
        </b-tabs>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { SET_MENU } from '@/core/services/store/modules/menu.module';
import { SideBar } from '@/core/config/menu/sideBar';
import SummaryTab from './SummaryTab.vue';
import DetailTab from './DetailTab.vue';
import VoucherPerformanceTab from './VoucherPerformanceTab.vue';

const KTCodePreview = () =>
  import(/* webpackPrefetch: true */ '@/view/content/CodePreview.vue');

export default {
  name: 'CommissionDebt',
  components: {
    KTCodePreview,
    SummaryTab,
    DetailTab,
    VoucherPerformanceTab,
  },
  data() {
    return {
      title: 'Công nợ commission NV',
      activeTab: 0,
      detailPrefill: null,
    };
  },
  mounted() {
    this.$store.dispatch(SET_MENU, SideBar.ACCOUNTANT);
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Kế toán' },
      { title: 'Công nợ' },
      { title: this.title },
    ]);
  },
  methods: {
    onDrilldown(payload) {
      this.detailPrefill = payload;
      this.activeTab = 1;
    },
  },
};
</script>

<style lang="scss" scoped>
// Không dùng ::v-deep override .nav-link / .nav-pills vì những class này
// là Bootstrap toàn cục — override sẽ leak sang page khác (ListBill, sidebar...).
// Giữ default style của b-tabs pills của BootstrapVue.
.commission-debt-page {
  // intentionally empty — wrapper class chỉ để namespace, không style ngầm
}
</style>
